import { client } from "@/api/client.gen";
import "./configure-api.ts";
import { auth } from "@/store/auth";
import { disconnectWs } from "@/store/ws";
import "./app-shell.ts";
import "@/store/motion";
import "@/styles/animations.css";
import "@/styles/motion-disable.css";

// Global API error handling. A 401 means the current session is unavailable.
// Clear local auth state and redirect once; do not call /auth/logout here,
// because that request is also unauthorized and can create a reload loop.
const AUTH_PATHS = ["/auth/login", "/auth/logout"];
let redirectingToLogin = false;

function isAuthEndpoint(url: string | undefined): boolean {
  return url != null && AUTH_PATHS.some((p) => url.includes(p));
}

function handleSessionExpired(): void {
  if (redirectingToLogin) return;
  if (window.location.pathname === "/auth/callback") return;

  redirectingToLogin = true;
  auth.value = { user: null, isLoading: false, isAuthenticated: false };
  disconnectWs();

  if (window.location.pathname !== "/login") {
    const next = window.location.pathname + window.location.search;
    window.location.replace(`/login?next=${encodeURIComponent(next)}`);
  }
}

// Error interceptors receive (error, response, request, options). The
// response carries the HTTP status; the request the URL.
client.interceptors.error.use(
  (error, response, request) => {
    const status = response?.status;
    const url = request?.url;
    if (status === 401 && !isAuthEndpoint(url) && auth.value.isAuthenticated) {
      handleSessionExpired();
    }
    throw error;
  },
);

// WebSocket session-expired handling. The WS layer dispatches this when its
// reconnect probe to /api/auth/me returns 401.
window.addEventListener("iris:session-expired", () => {
  handleSessionExpired();
});
